import * as React from "react";
import { TextField } from "office-ui-fabric-react/lib/TextField";
import { getAppStrings } from "../utils";

/* global Progress, Word, Office */

interface IMyTextFieldProps {
    id: string;
    gridArea: string;
    isRequired: boolean;
    isVisible: boolean;
    labelText: string;
    onChange: (value) => void;
    submitClicked: boolean;
    type?: string;
}

export function MyTextField(props: IMyTextFieldProps) {

    const { id, type, labelText, gridArea, isVisible, isRequired, submitClicked, onChange } = props;
    const [textValue, setTextValue] = React.useState<string>("");

    const onTextChange = (_ev: React.FormEvent<HTMLInputElement>, newValue?: string) => {
        setTextValue(newValue);
        onChange({ [id]: newValue });
    };

    const showError = () => {
        if (submitClicked && !textValue && isRequired) return "  ";
        if (textValue.length > 255) {
            const locale = Office.context.displayLanguage;
            const strings = getAppStrings(locale);
            return strings.errorMessageFieldName;
        }
        return undefined;
    };

    return (
        <TextField
            label={labelText}
            type={type || ""}
            required={isRequired}
            onChange={onTextChange}
            errorMessage={showError()}
            className={`ms-Custom-Field ${!isVisible && 'ms-Hidden-Field'}`}
            styles={{ root: { gridColumn: gridArea, gridRow: gridArea } }}
        />
    );
}
